import { Group, Text, TextProps, Tooltip } from "@mantine/core"
import { IconLock } from "@tabler/icons-react"
import { forwardRef, ReactNode } from "react"

import { useTextOverflow } from "../../utils/useTextOverflow"
import { Asterisk } from "../Asterisk/Asterisk"

import styles from "./Label.module.css"

type LabelProps = {
  disabledTooltip?: boolean
  label: ReactNode
  labelClassName?: string
  withAsterisk?: boolean
  tooltip?: string
  locked?: boolean
  onClick?: () => void
} & TextProps

export const Label = forwardRef<HTMLDivElement, LabelProps>(
  (
    {
      disabledTooltip = false,
      label,
      labelClassName,
      size = "xs",
      withAsterisk = false,
      fw = 400,
      fz = "xs",
      tooltip,
      locked = false,
      onClick,
      c = "var(--mantine-color-text)",
      ...props
    },
    ref
  ) => {
    const { textRef, isOverflowing } = useTextOverflow()
    return (
      <Tooltip
        label={tooltip || label}
        disabled={(disabledTooltip || !isOverflowing) && !tooltip}
        ref={ref}
      >
        <Group
          className={styles.labelWithEllipsis}
          maw="100%"
          gap={2}
          wrap="nowrap"
        >
          <Text
            span
            size={size}
            fw={fw}
            fz={fz}
            className={labelClassName}
            truncate="end"
            c={locked ? "gray.4" : c}
            ref={textRef}
            w="100%"
            onClick={onClick}
            {...props}
          >
            {label}
          </Text>
          {withAsterisk && <Asterisk />}
          {locked && <IconLock size={14} />}
        </Group>
      </Tooltip>
    )
  }
)
